import {
  GET_BOOKING_LIST,
  GET_BOOKING_LIST_FAILED,
  GET_BOOKING_LIST_SUCCESS,

  GET_BOOKING_DETAIL,
  GET_BOOKING_DETAIL_FAILED,
  GET_BOOKING_DETAIL_SUCCESS,
  EXPORT_BOOKING_LIST,
  EXPORT_BOOKING_LIST_SUCCESS,
  EXPORT_BOOKING_LIST_FAILED,

  CONFIRM_BOOKING,
  CONFIRM_BOOKING_SUCCESS,
  CONFIRM_BOOKING_FAILED,
} from './actionTypes';

export const actionGetBookingList = (payload) => ({
  payload,
  type: GET_BOOKING_LIST,
});

export const actionGetBookingListSuccess = (payload) => ({
  payload,
  type: GET_BOOKING_LIST_SUCCESS,
});

export const actionGetBookingListFailed = (payload) => ({
  payload,
  type: GET_BOOKING_LIST_FAILED,
});

export const actionExportBookingList = (payload) => ({
  payload,
  type: EXPORT_BOOKING_LIST,
});

export const actionExportBookingListSuccess = (payload) => ({
  payload,
  type: EXPORT_BOOKING_LIST_SUCCESS,
});

export const actionExportBookingListFailed = (payload) => ({
  payload,
  type: EXPORT_BOOKING_LIST_FAILED,
});

export const actionGetBookingDetail = (payload) => ({
  payload,
  type: GET_BOOKING_DETAIL,
});

export const actionGetBookingDetailSuccess = (payload) => ({
  payload,
  type: GET_BOOKING_DETAIL_SUCCESS,
});

export const actionGetBookingDetailFailed = (payload) => ({
  payload,
  type: GET_BOOKING_DETAIL_FAILED,
});

export const actionConfirmBooking = (payload) => ({
  payload,
  type: CONFIRM_BOOKING,
});

export const actionConfirmBookingSuccess = (payload, extra = {}) => ({
  payload,
  ...extra,
  type: CONFIRM_BOOKING_SUCCESS,
});

export const actionConfirmBookingFailed = (payload) => ({
  payload,
  type: CONFIRM_BOOKING_FAILED,
});
